"use client";

import { LoginPage } from "@scott/ui-b2b/pages/login-page";
import { type ReactNode, useState } from "react";
import type { Dictionary } from "../../../utils/dictionaries/get-dictionary";
import { clearStoredPlpViewMode } from "../../../utils/plp-view-preference";
import { OverlayLoadingSpinner } from "../../blocks/overlay-loading-spinner/overlay-loading-spinner";
import { loginAction } from "./login.action";

export type LoginPageClientProps = {
  dictionary: Dictionary;
  locale: string;
};

type State = {
  customerId: string;
  password: string;
  errorTitle?: string;
  errorDescription?: string;
  isLoading: boolean;
};

export function LoginPageClient(props: LoginPageClientProps): ReactNode {
  const [state, setState] = useState<State>({
    customerId: "",
    password: "",
    errorTitle: undefined,
    errorDescription: undefined,
    isLoading: false,
  });

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    clearStoredPlpViewMode();
    setState((prev) => ({ ...prev, isLoading: true, error: undefined }));

    const formData = new FormData();
    formData.append("id", state.customerId);
    formData.append("password", state.password);
    formData.append("language", props.locale);

    const result = await loginAction(undefined, formData);

    if (result && result.status === "error") {
      setState((prev) => ({
        ...prev,
        isLoading: false,
        errorTitle: props.dictionary.loginPage?.incorrectCredentials.title,
        errorDescription:
          props.dictionary.loginPage?.incorrectCredentials.description,
      }));
      return;
    }
    if (result && result.status === "service_unavailable") {
      setState((prev) => ({
        ...prev,
        isLoading: false,
        errorTitle: props.dictionary.loginPage?.serverMaintenance,
      }));
    }
  }

  const forgotPasswordHref = `/${props.locale}/forgot-password`;

  return (
    <>
      {state.isLoading ? (
        <OverlayLoadingSpinner
          loadingText={props.dictionary.layout?.loading || "Loading"}
        />
      ) : null}
      <LoginPage
        customerId={state.customerId}
        dictionary={props.dictionary.loginPage}
        errorDescription={state.errorDescription}
        errorTitle={state.errorTitle}
        forgotPasswordHref={forgotPasswordHref}
        isLoading={state.isLoading}
        onCustomerIdChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setState((prev) => ({ ...prev, customerId: e.target.value }))
        }
        onPasswordChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setState((prev) => ({ ...prev, password: e.target.value }))
        }
        onSubmit={handleSubmit}
        password={state.password}
      />
    </>
  );
}
